import React from "react"

import {FieldViewProps} from "../../../../render/view"

export default function FieldGoalType_View(props: FieldViewProps) {

    const option = props.field._getOption(props.model[props.field.fieldId])

    if (!option) return null

    const classes = Classes("ui5-txt-default fl-ac txt-truncate", props.className, {
        "m-t-4 m-b-4": !props.field.noDefaultPaddingMargin
    })

    // no color
    return (
        <div className={classes}>
            <div className={Classes('ui5-ico-14 m-r-5', option.icon)}/>
            <span className="txt-truncate">{option.label}</span>
        </div>
    )
}
